import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { DASHBOARD } from '@constants/routes';

// const Dashboard = lazy(
//   () => import('@features/dashboard/pages/dashboard/Dashboard')
// );
const NewDashboard = lazy(
  () => import('@features/dashboard/pages/new-dashboard')
);

export const DashboardRoutes: RouteObject[] = [
  {
    path: DASHBOARD.DASHBOARD,
    element: <NewDashboard />
  },
  {
    path: DASHBOARD.NEW_DASHBOARD,
    element: <NewDashboard />
  }
];

export default DashboardRoutes;
